// مدل خروجی سرور: MobileHistory_GetFleetStatusDashboard
export interface RootObject {
  strUnitID: string;
  strVehicleNo: string;
  strFullName: string;
  strMobile: string;
  strMobileType_strComment: string;
  strMobileGroup_strComment: string;
  strMobileDomain_strComment: string;
  strMobileIcon_strComment: string;
  strColor: string;
  iYearConstruction: number;
  strVIN: string;
  dtLastupdate?: any;
  strDate?: any;
  strTime?: any;
  iSpeed: number;
  bOnOff: boolean;
  tiDeviceStatus?: any;
  strDeviceStatus_strComment?: any;
  dLatitude?: any;
  dLongitude?: any;
  strPosName?: any;
  fLastKM: number;
  bActive: boolean;
  bHasGPS: boolean;
  iGPS: number;
  strGPS_strComment: string;
  bDashCam: boolean;
  bTanker: boolean;
  bFuelSensor: boolean;
  bTemperatureSensor: boolean;
  bWeightSensor: boolean;
  bOBD2: boolean;
  bFlowmeter: boolean;
  iMinutesSinceLastUpdate?: any;
  bActiveToday: boolean;
  bOnline: boolean;
  strOperationalStatus: string;
  strCommunicationGroup: string;
  strCommunicationStatus: string;
  iAttentionPriority: number;
}

export type FleetStatusFilter =
  | ''
  | 'Online'
  | 'Offline'
  | 'Never'
  | 'NoGPS'
  | 'Disabled'
  | 'Over7d'
  | '3d-7d'
  | '1d-3d';

export const COMM_GROUP_KEYS = [
  'Online',
  '15m-1h',
  '1h-3h',
  '3h-24h',
  '1d-3d',
  '3d-7d',
  'Over7d',
  'Never',
];
